import React from "react";
import { Box, Button, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

export type ContactSuccessMessageProps = {
  dashboardHref?: string;
};

const containerSx: SxProps<Theme> = {
  display: "flex",
  height: { xs: "auto", sm: "303px" },
  padding: { xs: "32px 12px", sm: "49px 1px" },
  flexDirection: "column",
  alignItems: "center",
  gap: { xs: "20px", sm: "34px" },
  flexShrink: 0,
  alignSelf: "stretch",
  width: "100%",
  border: "1px solid #E6E6E6",
  background: "rgba(248, 248, 248, 0.39)",
  boxShadow: "0 4px 14px 0 rgba(0, 0, 0, 0.05)",
};

const titleSx: SxProps<Theme> = {
  color: "#18181B",
  textAlign: "center",
  fontFamily: '"Repro", sans-serif',
  fontSize: { xs: "28px", sm: "40px" },
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "120%",
  letterSpacing: "-0.03px",
};

const subtitleSx: SxProps<Theme> = {
  color: "#18181B",
  textAlign: "center",
  fontFamily: '"Repro", sans-serif',
  fontSize: { xs: "16px", sm: "25px" },
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
  letterSpacing: "-0.03px",
};

const buttonSx: SxProps<Theme> = {
  borderRadius: "4px",
  border: "0 solid #FFF",
  background: "#355ADD",
  color: "#FFF",
  textTransform: "none",
  fontFamily: '"Repro", sans-serif',
  fontWeight: 700,
  px: "var(--spacing-6, 24px)",
  height: "40px",
  '&:hover': {
    backgroundColor: "#163190 !important",
  },
};

const ContactSuccessMessage: React.FC<ContactSuccessMessageProps> = ({ dashboardHref = "/" }) => {
  return (
    <Box sx={containerSx}>
      <Box aria-hidden sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: { xs: '8px', sm: '12px' }, flexWrap: 'wrap' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
          <path fillRule="evenodd" clipRule="evenodd" d="M2 13.9996C2.00043 8.03655 6.21308 2.90419 12.0617 1.74124C17.9103 0.578299 23.7659 3.70867 26.0476 9.21796C28.3292 14.7272 26.4014 21.0811 21.443 24.3937C16.4847 27.7063 9.87686 27.0551 5.66053 22.8384C3.3165 20.4941 1.99976 17.3147 2 13.9996Z" stroke="#5CBD81" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8.24963 13.9996L12.4155 18.1654L20.749 9.83378" stroke="#5CBD81" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <Typography component="h2" sx={titleSx}>Help is on the Way!</Typography>
      </Box>
      <Typography sx={subtitleSx}>We received your message and will respond within 24 hours.</Typography>
      <Button component="a" href={dashboardHref} sx={buttonSx}>Back to Dashboard</Button>
    </Box>
  );
};

export default ContactSuccessMessage;


